import { mapActions } from "pinia";
import { defineComponent } from "vue";
import { useConversationStore } from "../../store/useConversationStore";

export default defineComponent({
    data() {
        return {
            tutorialData: [
                {
                    label: "New Chat",
                    description: "Click new chat button to initiate conversations ",
                    icon: require("../../../../assets/images/chat/tut-new-chat.png")
                },
                {
                    label: "Share Profile",
                    description: "Instantly share patient profile and employee profile across your platform",
                    icon: require("../../../../assets/images/chat/tut-share-profile.png")
                },
                {
                    label: "Add Members",
                    description: "Add members to an existing conversation",
                    icon: require("../../../../assets/images/chat/tut-add-members.png")
                },
                {
                    label: "Calls",
                    description: "Start audio or video calls with your colleague or team",
                    icon: require("../../../../assets/images/chat/tut-calling.png")
                }
            ],
            currentIndex: 0
        };
    },

    methods: {
        ...mapActions(useConversationStore, ["setShowChatTutorial"]),

        handlePrev() {
            if (this.currentIndex === 0) {
                this.handleSkipTutorial();
            } else {
                this.currentIndex--;
            }
        },

        handleNext() {
            if (this.currentIndex === this.tutorialData.length - 1) {
                this.handleSkipTutorial();
            } else {
                this.currentIndex++;
            }
        },

        handleSkipTutorial() {
            this.setShowChatTutorial(false);
        }
    }
});
